jQuery(document).ready(function ($) {
  $(".product-gallery--slider.customslides").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    asNavFor: ".product-gallery--navigation",
    infinite: false,
  });

  $(".product-gallery--navigation").slick({
    slidesToShow: 8,
    slidesToScroll: 1,
    asNavFor: ".product-gallery--slider.customslides",
    dots: false,
    arrows: false,
    centerMode: false,
    focusOnSelect: true,
    infinite: false,
  });


$(document).ready(function () {
  var $slider = $('.relatedProdContainer-slider');

  // Initialize slider only if it exists
  if ($slider.length) {
    $slider.slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '.swiper-button-prev',
      nextArrow: '.swiper-button-next',
      dots: false,
      infinite: true
    });
  }

  // Toggle logic
    $('.relatedProductsToggle').on('click', function () {
    var $wrap = $(this).next('.relatedProducts-column');
    var $container = $(this).closest('.relatedProducts-wrap');
  
    // Toggle visibility
    $wrap.slideToggle(300, function () {
      if ($wrap.is(':visible')) {
        $slider.slick('setPosition');
      }
    });
  
    // Toggle class on container
    $container.toggleClass('open');
  });


  // Direct arrow clicks (optional)
  $('.swiper-button-prev').on('click', function () {
    $slider.slick('slickPrev');
  });

  $('.swiper-button-next').on('click', function () {
    $slider.slick('slickNext');
  });
});






  
});

